import React, { useState } from "react";
import { Observer } from "mobx-react-lite";
import { ModalStore } from "./ModalStore";
import { ModalContext } from "./hooks";

interface ModalStoreProviderProps {
    store?: ModalStore;
    children: React.ReactNode;
}

export const ModalStoreProvider: React.FC<ModalStoreProviderProps> = React.memo((props) => {
    const [modalStore] = useState(() => props?.store || new ModalStore());

    return (
        <ModalContext.Provider value={modalStore}>
            {props.children}
            <Observer>
                {/* @ts-ignore */}
                {() => {
                    return modalStore.needToRenderChildrenIds.map((id) => {
                        const Component = modalStore.modalsMapping.get(id);
                        const props = modalStore.modalPropsMapping.get(id);

                        return <Component {...props} key={id} />;
                    });
                }}
            </Observer>
        </ModalContext.Provider>
    );
});

export default React.memo(ModalStoreProvider);
